<template>
    <card class="spaced typo" v-show="loaded">

        <div class="pt-2" v-if="ctrl.rows.length || search">

            <h2 class="text-white mb-4">{{ $t('common.entities') }}</h2>

            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <base-table :data="ctrl.rows" :columns="columns">

                <template slot="columns">
                    <th>{{ $t('common.name') }}</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <td>
                        {{row.name}}
                    </td>
                    <td class="td-actions text-right">

                        <base-button icon link size="md" type="warning" @click="ctrl.update(row.id)">
                            <i class="tim-icons icon-pencil"></i>
                        </base-button>

                        <base-button icon link size="md" type="danger" @click="ctrl.delete(row.id)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </base-button>

                    </td>
                </template>

            </base-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <p class="text-center py-3" v-else>{{ $t('entities.no-entity') }}</p>
                
        <div class="text-center">
            <base-button type="primary" @click="ctrl.create()">
                {{ $t('entities.new') }}
            </base-button>
        </div>

        <portal to="modals">

            <modal class="no-footer" :title="$t('common.entity')" v-model="ctrl.modals.edit" :loading="ctrl.form.loading">
                <entity-form v-model="ctrl.form.data" :errors="ctrl.form.errors"></entity-form>
            </modal>

            <modal-confirm v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('entities.delete-confirm') }}</p>
            </modal-confirm>

        </portal>

    </card>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import EntityForm from './EntityForm'

    export default {

        components: {
            EntityForm
        },

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/entities',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['name'],
                        filters: { owner_id: this.$auth.owner.id }
                    }
                }),
                search: '',
                columns: ['name'],
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        watch: {
            search(val) {
                this.ctrl.filter({
                    name: {$text: val},
                    owner_id: this.$auth.owner.id,
                })
            }
        },

        methods: {
            
            mapData(entity) {
                return {
                    id: entity ? entity.id : null,
                    name: entity ? entity.name : null,
                }
            },

            unmapData(data) {
                let entity = {...data}
                entity.owner_id = this.$auth.owner.id
                return entity
            }
        }
    }
</script>
